import { render, staticRenderFns } from "./ZincForm.vue?vue&type=template&id=6d974fb2&scoped=true"
import script from "./ZincForm.vue?vue&type=script&lang=js"
export * from "./ZincForm.vue?vue&type=script&lang=js"
import style0 from "./ZincForm.vue?vue&type=style&index=0&id=6d974fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d974fb2",
  null
  
)

export default component.exports